<template>
	<div id="serviceHour">
		<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
			<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :error.sync="error" error-text="请求失败，点击重新加载">
				<van-cell :title="item.remarks" :label="item.createTime|formatDate" v-for="item in list" :value="item.serviceTime"/>
			</van-list>
		</van-pull-refresh>
	</div>
</template>

<script>
	import { Cell, CellGroup, Pagination, List, PullRefresh,Toast } from 'vant';
	import axios from 'axios';
	import global from '@/api/global';
	import Vue from 'vue';
	import VueCookies from 'vue-cookies';
	import { formatDate } from '@/js/common.js';
	Vue.use(VueCookies);
	export default {
		filters: {
			formatDate(time) {
				return formatDate(time, 'yyyy-MM-dd hh:mm:ss');
			}
		},
		components: {
			[Cell.name]: Cell,
			[CellGroup.name]: CellGroup,
			[Pagination.name]: Pagination,
			[List.name]: List,
			[PullRefresh.name]: PullRefresh,
			[Toast.name]:Toast
		},
		created: function() {

		},
		data() {
			return {
				isLoading: false,
				error: false,
				loading: false,
				finished: false,
				list: [], //消息列表
				count: 0, //总数
				page: 1, //页数
				limit: 10 //每页消息数
			}
		},
		methods: {
			onRefresh() {
				Toast.loading({
					mask: true,
					message: '加载中...',
					duration: 0
				});
				this.page = 1;
				this.list = [];
				axios({
					method: 'post',
					url: global.baseURL + 'appsite/serviceHour/selectList',
					params: {
						"limit": this.limit,
						"pageNum": this.page,
						auth_token: this.$cookies.get("auth_token")
					}
				}).then((resp) => {
					this.list = resp.data.data.data;
					this.count = resp.data.data.count;
					this.page++;
					this.isLoading = false;
					this.finished = false;
					this.error = false;
					this.loading = false;
					if(Math.ceil(this.count / this.limit) < this.page) {
						this.finished = true;
					}
					Toast.clear();
				}).catch(resp => {
					Toast.clear();
					console.log('请求失败：' + resp);
				});
			},
			onLoad() {
				Toast.loading({
					mask: true,
					message: '加载中...',
					duration: 0
				});
				axios({
					method: 'post',
					url: global.baseURL + 'appsite/serviceHour/selectList',
					params: {
						"limit": this.limit,
						"pageNum": this.page,
						auth_token: this.$cookies.get("auth_token")
					}
				}).then((resp) => {
					for(var i = 0; i < resp.data.data.data.length; i++) {
						this.list.push(resp.data.data.data[i]);
					}
					this.count = resp.data.data.count;
					this.isLoading = false;
					this.loading = false;
					this.page++;
					if(Math.ceil(this.count / this.limit) < this.page) {
						this.finished = true;
					}
					Toast.clear();
				}).catch(resp => {
					this.loading = false;
					Toast.clear();
					this.error = true;
					console.log('请求失败：' + resp);
				});
			}
		}
	}
</script>

<style>
	#serviceHour .van-cell__title {
		flex: 5;
	}
	#serviceHour .van-cell__value span{
		color: orangered;
	}
</style>